import { useMemo } from "react";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Header } from "./components/header";
import { GenerateControleEstoqueColumns } from "./columns/controle_estoque";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useNavigate } from "react-router";
import { useControleEstoqueCadastroViewModel } from "../../viewModels/controle_estoque_cadastro_view_model";
import { ItemControleEstoque } from "../../../domain/models/item_controle_estoque_lista";
import BottomBar from "../../../../../common/components/bottom_bar";
import { isValidId } from "../../../../../common/utils/utils";
import { ControleEstoqueModal } from "./components/controle_modal";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { BackButton } from "../../../../../common/components/back_button";

export const ItensControleLista = () => {

  const viewModel = useControleEstoqueCadastroViewModel();
  const navigate = useNavigate();

  const ControleEstoqueListalColumns = useMemo(() => {
    return GenerateControleEstoqueColumns({
      onActionDeletar: viewModel.handleDeleteModalOpenState,
      OnActionQtdeEstoqueMinChange: viewModel.handleQtdeEstoqueMinChange,
      OnActionQtdeEstoqueMaxChange: viewModel.handleQtdeEstoqueMaxChange,
      OnActionLocalArmazenamentoChange: viewModel.handleLocalArmazenamentoChange,
    });
  }, [viewModel.handleDeleteModalOpenState, viewModel.handleLocalArmazenamentoChange, viewModel.handleQtdeEstoqueMaxChange, viewModel.handleQtdeEstoqueMinChange]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={() => viewModel.handleSubmitReport()}
                  buttonColor="yellow">
                  Relatórios
                </PrimaryButton>
              </div>
              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroControleEstoqueOpenState(true)}>
                  Novo Item
                </PrimaryButton>
              </div>
              <BackButton onClick={() => navigate('/ControleEstoque_lista')} />
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Estoque
            </Link>
            <Typography className="text-primary-green">
              Itens de Controle
            </Typography>

          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white"> Itens de Controle</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleProdutorChange={viewModel.handlePesquisaChange}
            ProdutorPesquisa={viewModel.filters.ProdutoPesquisa}

          />
          <StyledDataGrid
            tableName=" Itens_Controle_lista"
            disableColumnMenu={false}
            getRowId={(row: ItemControleEstoque) => row.IdItemControleEstoque}
            columns={ControleEstoqueListalColumns}
            loading={viewModel.loading}
            rows={viewModel.itemControleLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ["IdControleEstoque"],
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />


        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.itemControleLista) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory()}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>
            <div className="flex flex-row gap-4 ml-auto">
              <div
                className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold"
                onClick={() => navigate('/ControleEstoque_lista')}
              >
                <h1 className="text-sm text-black dark:text-white">
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      onClick={viewModel.hookForm.handleSubmit(viewModel.handleUpdateMutiTodos)}
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>

          </div>
        </BottomBar>
      </form>

      <ControleEstoqueModal
        loading={viewModel.loading}
        onClose={() => viewModel.setItemControleModal(false)}
        onSubmit={viewModel.handleControleEstoqueSubmit}
        open={viewModel.itemControleModal}
        saving={viewModel.saving}
        handleProdutosServicosQueryChange={viewModel.handleProdutosServicosQueryChange}
        produtosServicosDropDown={viewModel.produtosServicosDropDown ?? []}
        selectedProdutosServicosQuery={viewModel.selectedProdutosServicosQuery}
      />
      <DeleteDialog
        open={viewModel.deleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirma} />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>
  )
};
